export default {
  name: 'Asteps',
  props: {
    active: { type: String | Number, default: () => '0' },
    data: { type: Array, default: () => null },
    items: { type: Array, default: () => null },
    config: { type: Array, default: () => null },
    option: { type: Array, default: () => null },
    options: { type: Array, default: () => null },
  },
  data() {
    return {
      current: 0,
    }
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      this.current = this.active;
    }
  },
  render() {
    const { ...attrs } = this.$attrs;
    const data = this.options || this.option || this.config || this.items || this.data || [];
    return data.length > 0 && (
      <div>
        <el-steps active={parseInt(this.current)} align-center {...{ attrs }}>
          {data.map((a, b) => (a.render ? () => a.render(a) : <el-step key={b} title={a.title} description={a.value} />))}
        </el-steps>
      </div>
    );
  }
}